/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {APP_SHARED} from '../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, TranslateModule],
  selector: 'adn-creative-set-recent',
  template: `<span class="label {{labelClass}}">{{ output }}</span>`
})
export class CreativeSetRecentlyRequestedComponent implements OnChanges {
  @Input() status: boolean;
  output = '';
  labelClass = '';

  ngOnChanges(): void {
    if (this.status) {
      this.output = 'Recently Requested';
      this.labelClass = 'label-success';
    } else {
      this.output = 'No Recent Requests';
      this.labelClass = 'label-warning';
    }
  }
}
